import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Stack, Typography } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { useMessageType } from "hooks/useMessageType";

export const Finished = () => {
  const { t } = useTenantTranslation();
  const messageType = useMessageType();

  return (
    <Stack alignItems="center" justifyContent="center" height="100%">
      <CheckCircleIcon sx={{ color: "success.main", height: 28, width: 28 }} />
      <Typography variant="h5" sx={{ mt: 1 }}>
        {t(`${messageType}_success`)}
      </Typography>
    </Stack>
  );
};
